export const getDateCopy = (
  deliveryDate: Date,
  weekdayFormat: 'short' | 'long' = 'long',
  monthFormat: 'short' | 'long' = 'long',
  includeWeekDay = true
) => {
  const weekday = deliveryDate.toLocaleString('default', { weekday: weekdayFormat });
  const month = deliveryDate.toLocaleString('default', { month: monthFormat });
  const date = deliveryDate.getDate();
  return `${includeWeekDay ? `${weekday}, ` : ''}${month} ${date}`;
};
